(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Filament"));
	else if(typeof define === 'function' && define.amd)
		define(["Filament"], factory);
	else if(typeof exports === 'object')
		exports["sceneview-web"] = factory(require("Filament"));
	else
		root["sceneview-web"] = factory(root["Filament"]);
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__650__) => {
return 